module.exports = __webpack_public_path__ + "img/border6.34897691.png";